import back from "./back.webp";
import front from "./front.webp";
import bottom from "./bottom.webp";
import top from "./top.webp";
import left from "./left.webp";
import right from "./right.webp";

export const deepspace1 = {
  back,
  front,
  bottom,
  top,
  left,
  right,
};
